import { z } from 'zod'
import { PASSWORD_MAX_LENGTH, PASSWORD_MIN_LENGTH } from '../constants/password-policy.ts'

export const LoginSchema = z.object({
  email: z.string().email('validation:emailInvalid'),
  password: z.string().min(8, 'validation:passwordMin'),
})

export const SignupSchema = z
  .object({
    email: z.string().email('validation:emailInvalid'),
    password: z
      .string()
      .min(PASSWORD_MIN_LENGTH, 'validation:passwordMin')
      .max(PASSWORD_MAX_LENGTH, 'validation:passwordMax'),
    confirmPassword: z
      .string()
      .min(PASSWORD_MIN_LENGTH, 'validation:confirmPasswordMin')
      .max(PASSWORD_MAX_LENGTH, 'validation:passwordMax'),
  })
  .refine(data => data.password === data.confirmPassword, {
    message: 'validation:passwordsMismatch',
    path: ['confirmPassword'],
  })

export type LoginInput = z.infer<typeof LoginSchema>
export type SignupInput = z.infer<typeof SignupSchema>
